module.exports = __webpack_public_path__ + "static/media/home-slide-mobile.bf42eadd.jpg";